import React, { Component } from "react";
import Link from "src/components/link";

export default class LodgingTabs extends Component {
  render() {
    const { tabs, currentTab, changeTab, baseURL } = this.props;

    return (
      <div>
         <nav className="flex space-x-4 p-6 overflow-x-auto" aria-label="Tabs">
            {tabs.map((tab, index) => {
              return (
                <Link href={baseURL ? `${baseURL}#${tab}` : null} className="flex justify-end items-center gap-1 text-xs" key={`tab-${index}`}>
                  <button
                    className={`${currentTab === index ? `border-2 bg-white border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]` : "border"} px-3 py-2 font-semibold text-sm rounded-2xl border-2 min-w-max`}
                    onClick={() => changeTab(index)}
                  >
                    {tab}
                  </button>
                </Link>
              )
            })}
        </nav>
        { tabs && tabs[currentTab] && tabs[currentTab].component &&
          <div className="px-4">
            {tabs[currentTab].component}
          </div>
        }
      </div>
    )
  }
}